import React, { useState } from 'react';

const fieldClass =
    'mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 disabled:bg-gray-100 disabled:text-gray-500';

export const emptyVehicleValues = () => ({
    vehicleQuery: '',
    engine: '',
    trim: '',
    fuelType: '',
    vin: '',
    notes: '',
});

export const isValidVin = (vin) => {
    if (!vin) return true;
    return /^[A-HJ-NPR-Z0-9]{17}$/i.test(String(vin).trim());
};

/**
 * Formulario libre: un campo "qué carro tienes" + opcionales de precisión.
 */
const CompatibilityVehicleForm = ({ values, onChange, disabled = false }) => {
    const [showExtra, setShowExtra] = useState(false);
    const set = (patch) => onChange({ ...values, ...patch });
    const vinInvalid = values.vin && !isValidVin(values.vin);
    const queryOk = String(values.vehicleQuery || '').trim().length >= 8;

    return (
        <div className="space-y-4">
            <label className="block text-sm font-semibold text-gray-700">
                ¿Qué carro tienes? *
                <input
                    className={`${fieldClass} text-base`}
                    value={values.vehicleQuery}
                    disabled={disabled}
                    onChange={(e) => set({ vehicleQuery: e.target.value })}
                    placeholder="Ej. Chevrolet Onix Turbo 2022"
                    autoComplete="off"
                />
                <span className="mt-1 block text-xs text-gray-500">
                    Escribe marca, línea y año como los digas. No hace falta elegir de una lista.
                    {!queryOk && values.vehicleQuery ? (
                        <span className="text-amber-700"> · Mínimo 8 caracteres.</span>
                    ) : null}
                </span>
            </label>

            <button
                type="button"
                disabled={disabled}
                onClick={() => setShowExtra((v) => !v)}
                className="text-xs font-bold text-indigo-700 hover:underline disabled:opacity-50"
            >
                {showExtra ? 'Ocultar precisión opcional' : 'Añadir más precisión (opcional)'}
            </button>

            {showExtra && (
                <div className="space-y-3 rounded-xl border border-gray-100 bg-gray-50 p-3">
                    <label className="block text-sm font-semibold text-gray-700">
                        Motor / cilindraje{' '}
                        <span className="text-amber-700 font-bold text-xs">(recomendado)</span>
                        <input
                            className={fieldClass}
                            value={values.engine}
                            disabled={disabled}
                            onChange={(e) => set({ engine: e.target.value })}
                            placeholder="Ej. 1.4, 1.6 16V"
                        />
                    </label>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <label className="text-sm font-semibold text-gray-700">
                            Versión / trim
                            <input
                                className={fieldClass}
                                value={values.trim}
                                disabled={disabled}
                                onChange={(e) => set({ trim: e.target.value })}
                                placeholder="Opcional"
                            />
                        </label>
                        <label className="text-sm font-semibold text-gray-700">
                            Combustible
                            <select
                                className={fieldClass}
                                value={values.fuelType}
                                disabled={disabled}
                                onChange={(e) => set({ fuelType: e.target.value })}
                            >
                                <option value="">Opcional</option>
                                <option value="Gasolina">Gasolina</option>
                                <option value="Diesel">Diésel</option>
                                <option value="Gas">Gas / GNV</option>
                                <option value="Hibrido">Híbrido</option>
                                <option value="Electrico">Eléctrico</option>
                            </select>
                        </label>
                    </div>

                    <label className="block text-sm font-semibold text-gray-700">
                        VIN
                        <input
                            className={`${fieldClass} uppercase ${vinInvalid ? 'border-red-400 focus:border-red-500 focus:ring-red-500' : ''}`}
                            value={values.vin}
                            disabled={disabled}
                            maxLength={17}
                            onChange={(e) => set({ vin: e.target.value.toUpperCase() })}
                            placeholder="Opcional — 17 caracteres"
                        />
                        {vinInvalid && (
                            <span className="mt-1 block text-xs font-medium text-red-600">
                                VIN inválido (17 caracteres, sin I/O/Q)
                            </span>
                        )}
                    </label>

                    <label className="block text-sm font-semibold text-gray-700">
                        Información adicional
                        <textarea
                            className={`${fieldClass} min-h-[72px]`}
                            value={values.notes}
                            disabled={disabled}
                            maxLength={255}
                            onChange={(e) => set({ notes: e.target.value })}
                            placeholder="Opcional — ej. versión europea, motor F14D3…"
                        />
                    </label>
                </div>
            )}
        </div>
    );
};

export default CompatibilityVehicleForm;
